import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CFIInformationPanel,
	MaterialOrderFilesButton,
	MaterialOrderInformationPanel,
	MaterialOrderNotes,
	MaterialOrderPage,
	MaterialOrderProducts,
	MaterialOrderReportType,
	PrintButton,
	PrintInvoiceButton,
	RequestMaterialCancellationButton
} from '../../../features/cfi/material-order';
import {
	ExitButton,
	NewMaterialOrderButton,
	PlumbingBanner,
	RetailOrderCommunicationButton,
	RetailOrderInformationCards,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	ShowMaterialDatesButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function RetailOrderMaterialPage() {

	return (

		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<MaterialOrderPage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'before'}>
						<NewMaterialOrderButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<PrintInvoiceButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<PrintButton elementAttr={{ 'data-testid': 'btn-print-material-order' }}
							buttonCaption='Print Material Order'
							reportType={MaterialOrderReportType.MaterialOrder} />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<ShowMaterialDatesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<RetailOrderCommunicationButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<RequestMaterialCancellationButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<ExitButton />
					</ToolbarItem>
				</Toolbar>
				<Box>
					<Item ratio={1}>
						<CFIInformationPanel />
					</Item>
					<Item ratio={1}>
						<MaterialOrderInformationPanel />
					</Item>
				</Box>

				<MaterialOrderProducts />

				<RetailOrderProducts showMaterialOrderInSummary={true} />

				<MaterialOrderNotes />

			</MaterialOrderPage>

		</RetailOrderPage>
	)
}
